import { useState } from "react";
import { useParams } from "react-router-dom";
import { registerResendLink } from "../api";
import Headline from "../Components/Elements/Headline";
import BtnPrimaryM from "../Components/Buttons/BtnPrimaryM";
import { useLanguage } from "../context/LanguageContext";
import Subheadline from "../Components/Elements/Subheadline";
import Toast from "../Components/Elements/Toast";

const RegisterResendLinkPage = () => {
  const { copy } = useLanguage();
  const { token } = useParams();

  const [toast, setToast] = useState({ message: "", type: "success" });

  const handleResendVerificationEmail = async () => {
    try {
      const response = await registerResendLink(token);
      console.log("Verification email sent again:", response);
      setToast({
        message: copy.register.errors.verification_email_resent,
        type: "success",
      });
    } catch (err) {
      console.error("Error resending verification email:", err.message);
      setToast({
        message: err.message || copy.register.errors.unable_to_resend,
        type: "error",
      });
    }
  };

  return (
    <>
      {toast.message && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "success" })}
        />
      )}
      <div className="w-full min-h-screen flex flex-col justify-center items-center background-page-color gap-8 h-screen">
        <a
          href="https://www.niumi.dk/"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-all duration-300 font-accent color-primary text-5xl"
        >
          NIUMI
        </a>
        <div className="flex flex-col gap-6 items-center">
          <Headline
            headline={copy.register.resend_link.headline}
            description={copy.register.resend_link.description}
            center
          />
        </div>

        <div className="card-base p-8 card-base-border bg-white w-[35vw] gap-6 flex flex-col">
          <>
            <Subheadline
              subheadline={copy.register.resend_link.subheadline}
              description={copy.register.resend_link.description_resend}
            />
            <div className="flex self-center">
              <BtnPrimaryM
                buttonCTA={copy.register.resend_link.button_resend}
                onClickLink={handleResendVerificationEmail}
              />
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default RegisterResendLinkPage;
